export default __webpack_public_path__ + "static/media/Snd_LowerEBall.08496de8.mp3";